import { render, staticRenderFns } from "./Solicitudes.vue?vue&type=template&id=bde4a258&scoped=true&"
import script from "./Solicitudes.vue?vue&type=script&lang=js&"
export * from "./Solicitudes.vue?vue&type=script&lang=js&"
import style0 from "./Solicitudes.vue?vue&type=style&index=0&id=bde4a258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde4a258",
  null
  
)

export default component.exports